import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { MockData, MockedEndpoint } from '../mock';

@Injectable()
export class MockInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<{ cmd: OpenServerRequestBody }>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!environment.useMock || request.method !== 'POST') {
      return next.handle(request);
    }

    if (MockedEndpoint[request.url]) {
      const response = MockedEndpoint[request.url](request.body);
      console.log('Using Mocked data', request, response);
      return of(new HttpResponse({ body: response, status: 200 })).pipe(delay(500));
    }

    const command = request.body?.cmd?.command;
    if (!command) {
      return next.handle(request);
    }

    if (MockData[command]) {
      const params = request.body?.cmd.params;
      const mockedResult = MockData[command].response(params);
      if (mockedResult) {
        const response = new HttpResponse({
          body: mockedResult,
          status: 200,
        });
        console.log('Using Mocked data', request, response);
        return of(response).pipe(delay(500));
      }
    }
    return next.handle(request);
  }
}

export type OpenServerRequestBody = {
  command: string;
  params: any;
};
